import api from './api';

const SubUserApi = {
  login: (loginRequest) => {
    return api.post('sub-user/login', loginRequest);
  },

  logout: (subUserId) => {
    return api.post(`sub-user/logout/${subUserId}`);
  },

  checkUsername: (username) => {
    return api.get(`sub-user/check/${username}`);
  },

  checkUserStatus: (subUserId) => {
    return api.get(`sub-user/status/user/${subUserId}`);
  },

  updateVersion: (id, appVersion) => {
    return api.patch(`sub-user/version/${id}/${appVersion}`);
  }
};

export default SubUserApi;
